import { Link } from 'react-router-dom';
import { Store } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const brandImageUrl = (path) => `${BACKEND_URL}/api/brands/images/${path}`;

export const BrandCard = ({ brand, isDark }) => {
  const cover = brand.image_paths?.[0];
  return (
    <Link
      to={`/brands/${brand.slug}`}
      data-testid={`brand-card-${brand.slug}`}
      className="group block relative overflow-hidden rounded-2xl transition-all hover:shadow-lg hover:-translate-y-0.5"
      style={{
        background: isDark ? '#1E2A36' : '#FFFFFF',
        border: `1px solid ${isDark ? 'rgba(212,164,168,0.35)' : 'rgba(83,65,69,0.2)'}`,
      }}
    >
      <div className="relative overflow-hidden" style={{ aspectRatio: '4 / 3', background: isDark ? '#2D4354' : '#F7F0EA' }}>
        {cover ? (
          <img
            src={brandImageUrl(cover)}
            alt={brand.brand_name}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <Store size={40} style={{ color: isDark ? '#D4A4A8' : '#534145', opacity: 0.4 }} />
          </div>
        )}
        {brand.category && (
          <span
            className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.14em] font-bold px-2.5 py-1 rounded-full"
            style={{ background: 'rgba(83,65,69,0.85)', color: '#FFFAF5', backdropFilter: 'blur(4px)' }}
          >
            {brand.category}
          </span>
        )}
      </div>
      <div className="p-4">
        <h3
          className="mb-1"
          style={{
            fontFamily: "'Bodoni Moda', serif",
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            fontSize: '17px',
            lineHeight: 1.2,
            color: isDark ? '#FFFAF5' : '#20212B',
          }}
        >
          {brand.brand_name}
        </h3>
        {brand.founder_name && (
          <p className="text-xs mb-2" style={{ color: isDark ? '#D4A4A8' : '#9E6752' }}>
            Founded by {brand.founder_name}
          </p>
        )}
        {brand.story && (
          <p
            className="text-sm leading-snug"
            style={{
              color: isDark ? 'rgba(255,250,245,0.7)' : 'rgba(83,65,69,0.85)',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {brand.story}
          </p>
        )}
      </div>
    </Link>
  );
};
